export const REPOST_GIGTYPE_ID=3
export const GENERAL_GIGTYPE_ID=6